import { purchaseOrderIdFormat } from "@redotech/redo-ids/ids";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const generatePurchaseOrderPdf = {
  name: "generatePurchaseOrderPdf" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    sendToEmails: z.array(z.string()).optional(),
    format: createEnum(["pdf", "csv"]).optional().default("pdf"),
    includeLogo: z.boolean().optional().default(true),
    includeShipments: z.boolean().optional().default(true),
    templateId: z.string().optional(),
    emailSubject: z.string().optional(),
    emailBody: z.string().optional(),
    emailCc: z.array(z.string()).optional(),
  }),
  output: z.object({
    url: z.string().optional(),
    pdfUrl: z.string().optional(),
    csvUrl: z.string().optional(),
    success: z.boolean(),
    message: z.string().optional(),
  }),
};
